<template> <!-- OK -->
    <div>
        <NavBar/>
        <StageManagement/>
    </div>
</template>

<script>

    import NavBar from '../components/NavBar.vue';
    import StageManagement from '../components/StageManagement.vue';

    export default {
        name: 'GerenciarEtapas',
        components: {
            NavBar, 
            StageManagement
        }
    }

</script>